
export default function MeDatabase() {
    return [
        {
            "title": "Software Engineer",
            "text": "Programming has been my passion for over 6 years now. I enjoy working on software architecture, performance and overall systems design. Currently I am working at Facebook.",
            "image": "https://i.ibb.co/VpL6sb6/software-engineers-vector.png",
        },
        {
            "title": "Traveler",
            "text": "I love traveling when I have a chance to do so! As I am located in Europe and have seen most of it, I am planning to explore Asia! While traveling alone can be great, I love doing it with my girlfriend and friends.",
            "image": "https://i.ibb.co/r4hw2sj/World-Travel-Free-Vector-World-Travel-Free-Vector.jpg",
        },
        {
            "title": "People Person",
            "text": "While programming is great, I love the aspect of people in it! Meetings, negotiations, discussions, sharing your input and knowledge. This is something important to me.",
            "image": "https://i.ibb.co/kqn7Q9Y/Vecteezy-People-Business-Illustrationba0421-generated.jpg",
        },
        {
            "title": "Gamer",
            "text": "Gaming has been a part of my life long before I started programming. Actually my interest in programming started from wanting to know: \"How the hell do those games even work!\".",
            "image": "https://i.ibb.co/Ld6TSQF/Playing-Video-Game.jpg",
        },
      
    ]
}